module.exports = __webpack_public_path__ + "img/json-push.8711f773.svg";